import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';

import { useAppSelector, useAppDispatch } from '../store';
import { useNavigate } from 'react-router-dom';
import { checkToken } from '../features';

function Index({ children, title }) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const userData = useAppSelector((state) => state.userData);
  const [loading, setLoading] = useState(true);

  React.useEffect(() => {
    if (userData.user) {
      dispatch(checkToken());
      setLoading(false);
    } else {
      // navigate('/login');
      setLoading(false);
    }
  }, [navigate]);

  return (
    <div className="bg-dry xl:h-screen flex-colo ">
      {
        loading ?
          <div className="flex justify-center items-center">
            <svg
              width='20'
              height='20'
              fill='currentColor'
              className='animate-spin'
              viewBox='0 0 1792 1792'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path d='M526 1394q0 53-37.5 90.5t-90.5 37.5q-52 0-90-38t-38-90q0-53 37.5-90.5t90.5-37.5 90.5 37.5 37.5 90.5zm498 206q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-704-704q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm1202 498q0 52-38 90t-90 38q-53 0-90.5-37.5t-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-964-996q0 66-47 113t-113 47-113-47-47-113 47-113 113-47 113 47 47 113zm1170 498q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-640-704q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm530 206q0 93-66 158.5t-158 65.5q-93 0-158.5-65.5t-65.5-158.5q0-92 65.5-158t158.5-66q92 0 158 66t66 158z'></path>
            </svg>
          </div>
          :
          <div className="grid xl:grid-cols-12 w-full 2xl:max-w-[2000px]">
            <div className="col-span-2 xl:block hidden h-screen overflow-auto">
              <Sidebar />
            </div>
            <div className="col-span-10 xl:h-screen overflow-y-auto relative">
              <Header title={title} />
              <div className="xs:px-8 px-2 pt-24">{children}</div>
            </div>
            {/* <div className="col-span-10 xl:h-screen overflow-y-auto relative">
              <Header title={title} />
              <div className="xs:px-8 px-2 pt-24">{children}</div>
            </div> */}
          </div>
      }
    </div>
  );
}

export default Index;
